































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetTerms } from "@/request/projects";
@Component({})
export default class Zhengzhuangtishi extends Vue {
  @Prop()
  private model: any;
  @Prop()
  private message: any;
  private zhengzhuangs: any[] = [];
  private messageChange(message) {
    this.$emit("update:message", message);
  }
  /**
   * @description 症状搜索
   */
  private fetchZhengzhuangs(value) {
    const params: any = {
      params: {
        type: "中医症状",
        search: value
      }
    };
    GetTerms(this, params).then((data: any) => {
      if (
        this.message.info["刻下症"] &&
        this.message.info["刻下症"].length > 0
      ) {
        this.zhengzhuangs = _.uniqBy(
          data.concat(this.message.info["刻下症"]),
          "id"
        );
      } else {
        this.zhengzhuangs = data;
      }
    });
  }
}
